module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("GEORGIA DEFENSE EXCHANGE (GDX) ADMINISTRATION MODULE TUTORIALS")]), _vm._v(" "), _c('p', [_vm._v("Please use the links below to watch step-by-step tutorials on how to use the Administration Module in the Georgia Defense Exchange")]), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "faq-list",
    attrs: {
      "focusable": ""
    }
  }, _vm._l((_vm.tutorials), function(item, index) {
    return _c('v-expansion-panel-content', {
      key: index
    }, [_c('h3', {
      staticClass: "expansion-header",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(item.order) + ". " + _vm._s(item.question))]), _vm._v(" "), _c('v-card', {
      staticClass: "faq-content"
    }, [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [(item.mediaType.length && item.mediaType === 'image') ? _c('img', {
      staticClass: "faq-media",
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "src": item.media
      }
    }) : _vm._e(), _vm._v(" "), (item.mediaType.length && item.mediaType === 'video') ? _c('iframe', {
      attrs: {
        "src": item.media.embedUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "faq-text",
      domProps: {
        "innerHTML": _vm._s(item.answer)
      }
    })])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12064dae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Tutorial/AllTutorials.vue
// module id = 1642
// module chunks = 5